import Alert from 'nj-components/Alert';
import Checkbox from 'nj-components/Checkbox';
import Collapse from 'nj-components/Collapse';
import CollapseSearchBar from 'nj-components/CollapseSearchBar';
import Dropdown from 'nj-components/Dropdown';
import Fab from 'nj-components/Fab';
import Modal from 'nj-components/Modal';
import Navbar from 'nj-components/Navbar';
import PasswordInput from 'nj-components/PasswordInput';
import Radio from 'nj-components/Radio';
import SearchInput from 'nj-components/SearchInput';
import Select from 'nj-components/Select';
import Slider from 'nj-components/Slider';
import Tag from 'nj-components/Tag';
import Text from 'nj-components/Text';
import Textarea from 'nj-components/Textarea';
import Toggle from 'nj-components/Toggle';
import Tooltip from 'nj-components/Tooltip';

const NJ_COMPONENTS = [
  Alert,
  Checkbox,
  Collapse,
  CollapseSearchBar,
  Dropdown,
  Fab,
  Modal,
  Navbar,
  PasswordInput,
  Radio,
  SearchInput,
  Select,
  Slider,
  Tag,
  Text,
  Textarea,
  Toggle,
  Tooltip
];

// Some component are opt-in for performance reasons,
// so you must initialize them yourself
const AUTO_INIT_EXCLUDE = [
  Tooltip
];

class NJ {
  static components = [];

  // ------------------------------------------------------------------------
  // Static

  static resolveSelector(Component) {
    let selector = Component.selector;

    if (typeof selector === 'object') {
      selector = Object.values(selector).join(', ');
    }

    return selector;
  }

  static AutoInit() {
    try {
      Object.values(NJ_COMPONENTS)
        .filter((component) => AUTO_INIT_EXCLUDE.indexOf(component) === -1)
        .forEach((component) => {
          // const selector = NJ.resolveSelector(component);
          component.init({});
        });
    } catch (error) {
      console.error('Error while loading components : ', error);
    }
  }
}

// Attach component to the main Object
NJ.Alert = Alert;
NJ.Checkbox = Checkbox;
NJ.Collapse = Collapse;
NJ.CollapseSearchBar = CollapseSearchBar;
NJ.Dropdown = Dropdown;
NJ.Fab = Fab;
NJ.Modal = Modal;
NJ.Navbar = Navbar;
NJ.PasswordInput = PasswordInput;
NJ.Radio = Radio;
NJ.SearchInput = SearchInput;
NJ.Select = Select;
NJ.Slider = Slider;
NJ.Tag = Tag;
NJ.Text = Text;
NJ.Textarea = Textarea;
NJ.Toggle = Toggle;
NJ.Tooltip = Tooltip;

export default NJ;
